// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Pflegehelden authentic brand colors */
:root {
  --primary-coral: #F56565;
  --primary-coral-dark: #E53E3E;
  --primary-coral-light: #FF8A8A;
  --secondary-pink: #FFB3BA;
  --secondary-pink-light: #FFDEE0;
  --accent-coral: #FF6B7A;
  --light-gray: #F7FAFC;
  --medium-gray: #E2E8F0;
  --dark-gray: #4A5568;
  --text-dark: #2D3748;
  --text-light: #718096;
  --white: #FFFFFF;
  --shadow: 0 2px 4px rgba(245, 101, 101, 0.1);
  --shadow-hover: 0 4px 8px rgba(245, 101, 101, 0.15);
  --border-radius: 12px;
  --transition: all 0.3s ease;
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: linear-gradient(135deg, var(--light-gray) 0%, var(--white) 100%);
  color: var(--text-dark);
  line-height: 1.6;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

/* Global button styles */
button {
  background: var(--primary-coral);
  color: var(--white);
  border: none;
  padding: 12px 24px;
  border-radius: var(--border-radius);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
  box-shadow: var(--shadow);
}

button:hover {
  background: var(--primary-coral-dark);
  box-shadow: var(--shadow-hover);
  transform: translateY(-1px);
}

button:disabled {
  background: var(--medium-gray);
  color: var(--text-light);
  cursor: not-allowed;
  transform: none;
}

button.secondary {
  background: var(--secondary-pink);
  color: var(--text-dark);
}

button.secondary:hover {
  background: var(--accent-coral);
  color: var(--white);
}

button.accent {
  background: var(--accent-coral);
}

button.accent:hover {
  background: var(--primary-coral-dark);
}

/* Input styles */
input, textarea {
  border: 2px solid var(--medium-gray);
  border-radius: var(--border-radius);
  padding: 12px 16px;
  font-size: 14px;
  transition: var(--transition);
  font-family: inherit;
}

input:focus, textarea:focus {
  outline: none;
  border-color: var(--primary-coral);
  box-shadow: 0 0 0 3px rgba(245, 101, 101, 0.1);
}

/* Card styles */
.card {
  background: var(--white);
  border-radius: var(--border-radius);
  box-shadow: var(--shadow);
  transition: var(--transition);
}

.card:hover {
  box-shadow: var(--shadow-hover);
}

/* Header styles */
h1, h2, h3, h4, h5, h6 {
  color: var(--text-dark);
  margin-top: 0;
}

h1 {
  color: var(--primary-coral);
  font-size: 2.5rem;
  font-weight: 700;
}

h2 {
  color: var(--primary-coral);
  font-size: 2rem;
  font-weight: 600;
}

h3 {
  font-size: 1.5rem;
  font-weight: 600;
}

/* Loading and status styles */
.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  color: var(--text-light);
  font-size: 16px;
}

.error {
  color: var(--primary-coral-dark);
  background: var(--secondary-pink-light);
  border: 1px solid var(--secondary-pink);
  padding: 12px 16px;
  border-radius: var(--border-radius);
  margin: 16px 0;
}

.success {
  color: var(--primary-coral);
  background: var(--secondary-pink-light);
  border: 1px solid var(--secondary-pink);
  padding: 12px 16px;
  border-radius: var(--border-radius);
  margin: 16px 0;
}

/* Logo styles */
.logo {
  height: 40px;
  width: auto;
}

.logo-large {
  height: 60px;
  width: auto;
}

.brand-text {
  color: var(--primary-coral);
  font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,8BAA8B;EAC9B,yBAAyB;EACzB,+BAA+B;EAC/B,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,4CAA4C;EAC5C,mDAAmD;EACnD,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,4DAA4D;EAC5D,mCAAmC;EACnC,kCAAkC;EAClC,4EAA4E;EAC5E,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,+EAA+E;AACjF;;AAEA,yBAAyB;AACzB;EACE,gCAAgC;EAChC,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,iBAAiB;AACjB;EACE,oCAAoC;EACpC,mCAAmC;EACnC,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA,gBAAgB;AAChB;EACE,wBAAwB;EACxB,mCAAmC;EACnC,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;EACvC,uCAAuC;EACvC,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;EACvC,uCAAuC;EACvC,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB","sourcesContent":["/* Pflegehelden authentic brand colors */\n:root {\n  --primary-coral: #F56565;\n  --primary-coral-dark: #E53E3E;\n  --primary-coral-light: #FF8A8A;\n  --secondary-pink: #FFB3BA;\n  --secondary-pink-light: #FFDEE0;\n  --accent-coral: #FF6B7A;\n  --light-gray: #F7FAFC;\n  --medium-gray: #E2E8F0;\n  --dark-gray: #4A5568;\n  --text-dark: #2D3748;\n  --text-light: #718096;\n  --white: #FFFFFF;\n  --shadow: 0 2px 4px rgba(245, 101, 101, 0.1);\n  --shadow-hover: 0 4px 8px rgba(245, 101, 101, 0.15);\n  --border-radius: 12px;\n  --transition: all 0.3s ease;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: linear-gradient(135deg, var(--light-gray) 0%, var(--white) 100%);\n  color: var(--text-dark);\n  line-height: 1.6;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n/* Global button styles */\nbutton {\n  background: var(--primary-coral);\n  color: var(--white);\n  border: none;\n  padding: 12px 24px;\n  border-radius: var(--border-radius);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition);\n  box-shadow: var(--shadow);\n}\n\nbutton:hover {\n  background: var(--primary-coral-dark);\n  box-shadow: var(--shadow-hover);\n  transform: translateY(-1px);\n}\n\nbutton:disabled {\n  background: var(--medium-gray);\n  color: var(--text-light);\n  cursor: not-allowed;\n  transform: none;\n}\n\nbutton.secondary {\n  background: var(--secondary-pink);\n  color: var(--text-dark);\n}\n\nbutton.secondary:hover {\n  background: var(--accent-coral);\n  color: var(--white);\n}\n\nbutton.accent {\n  background: var(--accent-coral);\n}\n\nbutton.accent:hover {\n  background: var(--primary-coral-dark);\n}\n\n/* Input styles */\ninput, textarea {\n  border: 2px solid var(--medium-gray);\n  border-radius: var(--border-radius);\n  padding: 12px 16px;\n  font-size: 14px;\n  transition: var(--transition);\n  font-family: inherit;\n}\n\ninput:focus, textarea:focus {\n  outline: none;\n  border-color: var(--primary-coral);\n  box-shadow: 0 0 0 3px rgba(245, 101, 101, 0.1);\n}\n\n/* Card styles */\n.card {\n  background: var(--white);\n  border-radius: var(--border-radius);\n  box-shadow: var(--shadow);\n  transition: var(--transition);\n}\n\n.card:hover {\n  box-shadow: var(--shadow-hover);\n}\n\n/* Header styles */\nh1, h2, h3, h4, h5, h6 {\n  color: var(--text-dark);\n  margin-top: 0;\n}\n\nh1 {\n  color: var(--primary-coral);\n  font-size: 2.5rem;\n  font-weight: 700;\n}\n\nh2 {\n  color: var(--primary-coral);\n  font-size: 2rem;\n  font-weight: 600;\n}\n\nh3 {\n  font-size: 1.5rem;\n  font-weight: 600;\n}\n\n/* Loading and status styles */\n.loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n  color: var(--text-light);\n  font-size: 16px;\n}\n\n.error {\n  color: var(--primary-coral-dark);\n  background: var(--secondary-pink-light);\n  border: 1px solid var(--secondary-pink);\n  padding: 12px 16px;\n  border-radius: var(--border-radius);\n  margin: 16px 0;\n}\n\n.success {\n  color: var(--primary-coral);\n  background: var(--secondary-pink-light);\n  border: 1px solid var(--secondary-pink);\n  padding: 12px 16px;\n  border-radius: var(--border-radius);\n  margin: 16px 0;\n}\n\n/* Logo styles */\n.logo {\n  height: 40px;\n  width: auto;\n}\n\n.logo-large {\n  height: 60px;\n  width: auto;\n}\n\n.brand-text {\n  color: var(--primary-coral);\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
